import React, { useState, useEffect } from "react";
import { Eye, ArrowRight, ChevronDown } from "lucide-react";

const HomeHeader = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const navegarA = (seccion) => {
        if (seccion === 'registro') {
            window.location.href = '/signup';
        } else {
            document.getElementById(seccion)?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section id="home" className="relative min-h-screen flex items-center justify-center px-4 pt-20 overflow-hidden">
            {/* Desktop Background Video */}
            <div className="hidden md:block absolute inset-0 w-full h-full">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover"
                >
                    <source
                        src="https://firebasestorage.googleapis.com/v0/b/xfinance-12e10.firebasestorage.app/o/Headers%2Flibertad%20miguel.mov?alt=media&token=5befd377-fd7d-471e-9859-2c982f96cec0"
                        type="video/mp4"
                    />
                    Tu navegador no soporta videos HTML5.
                </video>

                {/* Desktop Video Overlay */}
                <div className="absolute inset-0 bg-black/40"></div>
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/60"></div>
            </div>

            {/* Mobile Background */}
            <div className="md:hidden absolute inset-0 bg-gradient-to-br from-green-50 to-white"></div>

            <div
                className={`max-w-6xl mx-auto text-center relative z-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
                    }`}
            >
                {/* Mobile Video Card */}
                <div className="md:hidden mb-8">
                    <div className="relative w-full max-w-sm mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border-4 border-[#14840c]/20">
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="w-full h-48 object-cover"
                        >
                            <source
                                src="https://firebasestorage.googleapis.com/v0/b/xfinance-12e10.firebasestorage.app/o/Headers%2Flibertad%20miguel.mov?alt=media&token=5befd377-fd7d-471e-9859-2c982f96cec0"
                                type="video/mp4"
                            />
                        </video>

                        {/* Mobile Video Overlay with Logo */}
                        <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                            <div className="text-center">
                                <img
                                    src="https://static.wixstatic.com/media/755cdc_fba32a57a6554eb9b4205d19bf8f419e~mv2.png/v1/fill/w_518,h_98,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo%20verde.png"
                                    alt="MiguelMX"
                                    className="h-8 w-auto object-contain filter brightness-0 invert mx-auto mb-2"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'block';
                                    }}
                                />
                                <div className="text-white font-bold text-xl drop-shadow-lg hidden">MiguelMX</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <h1 className="text-4xl md:text-7xl font-black text-slate-900 md:text-white mb-8 leading-tight md:drop-shadow-2xl">
                    Tu tranquilidad financiera
                    <br />
                    <span className="text-[#14840c] md:drop-shadow-lg">empieza aquí.</span>
                </h1>

                <p className="text-lg md:text-2xl text-slate-600 md:text-white/95 mb-12 max-w-4xl mx-auto leading-relaxed font-medium md:drop-shadow-lg">
                    En <span className="text-[#14840c] font-semibold">MiguelMX®</span> te ayudamos a tomar decisiones financieras con
                    <span className="text-slate-900 md:text-white font-semibold"> claridad, estrategia y confianza.</span>
                </p>

                <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
                    <button
                        onClick={() => navegarA('servicios')}
                        className="group bg-[#14840c] text-white px-8 md:px-10 py-3 md:py-4 rounded-lg font-semibold text-base md:text-lg hover:bg-green-700 transition-all duration-300 shadow-lg md:shadow-xl hover:shadow-xl md:hover:shadow-2xl hover:scale-105 flex items-center md:backdrop-blur-sm"
                    >
                        <Eye className="w-4 md:w-5 h-4 md:h-5 mr-2 md:mr-3 group-hover:scale-110 transition-transform" />
                        Explorar Servicios
                    </button>
                    <button
                        onClick={() => navegarA('registro')}
                        className="group border-2 border-[#14840c] text-[#14840c] md:bg-white/90 md:backdrop-blur-sm md:border-white md:text-[#14840c] px-8 md:px-10 py-3 md:py-4 rounded-lg font-semibold text-base md:text-lg hover:bg-[#14840c] hover:text-white md:hover:bg-white md:hover:shadow-xl transition-all duration-300 flex items-center shadow-sm md:shadow-lg"
                    >
                        <ArrowRight className="w-4 md:w-5 h-4 md:h-5 mr-2 md:mr-3 group-hover:scale-110 transition-transform" />
                        Comenzar Ahora
                    </button>
                </div>

                {/* Scroll Indicator */}
                <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                    <ChevronDown className="w-6 h-6 text-slate-400 md:text-white/70 md:drop-shadow-lg" />
                </div>
            </div>
        </section>
    );
};

export default HomeHeader;